import { jsxs as c, jsx as r, Fragment as T } from "react/jsx-runtime";
import { useButton as E } from "@react-aria/button";
import { useDialog as R } from "@react-aria/dialog";
import l from "classnames";
import w, { useRef as m, useState as P, useEffect as H } from "react";
import { useIntl as B } from "react-intl";
import { I as S } from "./Icon-BcAne5bE.js";
import "./Modal-ZoeQxXVj.js";
import { u as j } from "./useBreakpoints-JBHunbIk.js";
import { commonMessages as A } from "./helpers/messages.js";
import { V as L } from "./VisuallyHidden-42oizZZl.js";
import { useModalOverlay as V, Overlay as F, useOverlayTrigger as q } from "@react-aria/overlays";
import { useOverlayTriggerState as G } from "@react-stately/overlays";
import { B as J } from "./Button-ClBViKhc.js";
const p = 200, le = ({
  children: s,
  headerChildren: t,
  title: o,
  onClose: e,
  marginTop: a = 55,
  headerBlockPadding: i = 16,
  className: n,
  headerClassName: d,
  contentClassName: M,
  absoluteCloseBtn: g,
  variant: h = "default",
  showDialog: _ = !0,
  ...v
}) => {
  const O = {
    ...v,
    "aria-label": v["aria-label"] ?? (typeof o == "string" ? o : void 0)
  }, y = m(null), u = m(null), { dialogProps: $, titleProps: N } = R(O, y), [D, I] = P(0), { isMobile: k } = j(), [z, b] = P(!1);
  return H(() => {
    const f = () => {
      u.current && I(u.current.clientHeight);
    };
    return u.current && f(), window.addEventListener("resize", f), () => {
      window.removeEventListener("resize", f);
    };
  }, []), H(() => {
    _ ? setTimeout(() => {
      b(!0);
    }, p) : (b(!1), e && setTimeout(() => {
      e();
    }, p));
  }, [_, e]), /* @__PURE__ */ c(
    "div",
    {
      ...$,
      ref: y,
      className: l("ds-dialog", `ds-dialog--${h}`, n, {
        "--animated-dialog": z
      }),
      style: {
        marginTop: `${a}px`,
        "--animation-duration": `${p / 1e3}s`
      },
      children: [
        (o || e) && /* @__PURE__ */ c(
          "header",
          {
            className: l("ds-dialog__header", o?.className, d),
            ref: u,
            children: [
              /* @__PURE__ */ c("div", { className: "ds-dialog__header__title-container", children: [
                o && /* @__PURE__ */ r(
                  o.as,
                  {
                    ...N,
                    className: l("ds-dialog__title roboto", N.className),
                    children: o.content
                  }
                ),
                (h !== "attach-to-bottom-on-mobile" || !k) && e && !g && /* @__PURE__ */ r(x, { onPress: e })
              ] }),
              t
            ]
          }
        ),
        e && g && /* @__PURE__ */ r(x, { onPress: e, absoluteCloseBtn: g }),
        s && /* @__PURE__ */ r(
          "div",
          {
            className: l("ds-dialog__content", M),
            style: {
              "--dialogHeaderHeight": `${D}px`,
              "--marginTop": `${a}px`,
              "--doubleHeaderBlockPadding": `${i * 2}px`
            },
            children: s
          }
        )
      ]
    }
  );
}, x = ({
  absoluteCloseBtn: s,
  ...t
}) => {
  const o = B(), e = m(null), { buttonProps: a } = E(t, e);
  return /* @__PURE__ */ c(
    "button",
    {
      ...a,
      ref: e,
      className: l("close-dialog__button", {
        "close-dialog__button--absolute": s
      }),
      children: [
        /* @__PURE__ */ r(L, { children: o.formatMessage(A.close) }),
        /* @__PURE__ */ r(S, { path: "close", size: "medium", color: "var(--text-main-default)" })
      ]
    }
  );
}, K = ({
  className: s,
  state: t,
  children: o,
  variant: e = "default",
  ...a
}) => {
  const i = m(null), { modalProps: n, underlayProps: d } = V(a, t, i);
  return /* @__PURE__ */ r(T, { children: t.isOpen && /* @__PURE__ */ r(F, { children: /* @__PURE__ */ r(
    "div",
    {
      className: l(
        "ds-legacy-modal__background",
        `ds-legacy-modal__background--${e}`
      ),
      ...d,
      children: /* @__PURE__ */ r(
        "div",
        {
          ...n,
          ref: i,
          className: l("ds-legacy-modal", s),
          role: "dialog",
          children: o
        }
      )
    }
  ) }) });
}, ne = ({
  children: s,
  buttonProps: t,
  modalClassname: o,
  ...e
}) => {
  const a = G(e), i = m(null), { triggerProps: n, overlayProps: d } = q(
    { type: "dialog" },
    a,
    i
  );
  return /* @__PURE__ */ c(T, { children: [
    /* @__PURE__ */ r(J, { ...t, ...n, ref: i }),
    a.isOpen && /* @__PURE__ */ r(K, { ...e, state: a, className: o, children: w.cloneElement(s(a.close), d) })
  ] });
};
export {
  le as D,
  K as M,
  ne as a
};
//# sourceMappingURL=ModalPortal-DLviGtlj.js.map
